import { ILocation } from "../../types/models";
import { Badge } from "antd";


const CONTENT_FIELDS: (keyof ILocation)[] = ['description', 'hero_description', 'hero_image', 'why_image', 'small_ft_image', 'owning_image', 'why_excerpt', 'why_description'];


function DestinationContentStatus({ destination }: { destination: ILocation }) {

  if (CONTENT_FIELDS.reduce((prev, curr) => prev && !!destination[curr], true)) return (
    <Badge status="success" text="Ready" />
  )

  return (
    <span><Badge status="warning" />
      Missing:
      {' '}
      {
        CONTENT_FIELDS
          .filter(f => !destination[f])
          .map(f => f.replaceAll("_", " "))
          .join(", ")
      }
    </span>
  )
}

export default DestinationContentStatus;
